import { usePricingModulesState } from '../../context/contexts/PricingModuleContext';
import { Pages, Roles } from '../../context/contexts/UserContext/permissionsTypes';
import { LogicalRoute, LogicalRouteImportProps } from '../helpers/LogicalRoute';
import useHasPermissions from '../../hooks/useHasPermissions';
import { CloudISPMBlockPage } from '../../modules/ispm/ISPMBlockPage/CloudISPMBlockPage';
import CloudIspm from '../../modules/ispm/Cloud/CloudIspm';
import { LAYOUT_TABS } from '@silverfort-nodelibs/common/utils/consts';

export const IspmCloudRouting = (props: LogicalRouteImportProps) => {
    const { isPageBlocked } = usePricingModulesState();

    const hasOnPremPermission = useHasPermissions({ permission: Pages.INSIGHTS, role: Roles.VIEWER });
    const displayBlockPage = isPageBlocked(LAYOUT_TABS.INSIGHTS_CLOUD.ID);

    return (
        <LogicalRoute
            {...props}
            component={CloudIspm}
            disabled={!hasOnPremPermission}
            blockPageComponent={CloudISPMBlockPage}
            displayBlockPage={displayBlockPage}
        />
    );
};
